import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';

import { useTheme } from 'contexts/ThemeContext';

import Icon from 'utils/icons';

import { AssetItem } from 'components/AssetItem';
import { Text, Tooltip } from 'components/DataDisplay';
import { IconButton, Switch, TextField } from 'components/Inputs';
import { Item, Row } from 'components/Layout';

const publicInventoryToggle = (
  isDv360Setup,
  ad,
  setAds,
  handleSaveAd,
  isCampaignSetupPending,
  forcePublicInventoryDisabled
) => {
  const hasDeals = Array.isArray(ad?.dealIds) && ad.dealIds.length > 0;
  if (isDv360Setup) {
    return (
      <Item xs={11} justify="flex-start" style={{ maxWidth: '350px' }}>
        <Text style={{ marginRight: '10px' }}>Inventory public DV360</Text>
        <Switch
          disabled={
            isCampaignSetupPending || !hasDeals || forcePublicInventoryDisabled
          }
          checked={
            !forcePublicInventoryDisabled && (ad.isChecked || !hasDeals)
          }
          onChange={() => {
            setAds(prevAds =>
              prevAds.map(crea => {
                if (crea.id === ad.id) {
                  return {
                    ...crea,
                    publicInventory: !ad.isChecked,
                    isChecked: !ad.isChecked
                  };
                }
                return crea;
              })
            );
            handleSaveAd(ad.id, {
              ...ad,
              publicInventory: !ad.isChecked
            });
          }}
          options={['Non', 'Oui']}
        />
      </Item>
    );
  }
  return <></>;
};
export const AdItem = props => {
  const {
    isCampaignSetupPending,
    ad,
    getStatusChip,
    asset,
    setAds,
    activableMedia,
    mediaSetupTask,
    handleSaveAd,
    handleSaveExternalId,
    isLeadGen,
    isDv360Setup = false,
    forcePublicInventoryDisabled = false
  } = props;
  const { themeColors } = useTheme();
  const { postData = null } = ad;

  return (
    <Row spacing={1} key={ad.id}>
      <Item
        justify="flex-start"
        style={{
          marginLeft: '80px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {(asset || postData?.mediaUrl) && (
          <Tooltip
            title={<AssetItem asset={asset} mediaUrl={postData?.mediaUrl} />}
          >
            <Icon
              icon="creaIcon"
              attrs={{
                fill: themeColors.light
              }}
            />
          </Tooltip>
        )}
        &nbsp;
        <Text fontSize="14px" fontWeight={400}>
          {ad.availableCreative?.name || 'Asset introuvable'}
        </Text>
        {getStatusChip(activableMedia, mediaSetupTask)}
        {!ad.isEditing ? (
          <>
            {ad.leadGenFormId && isLeadGen && (
              <Text fontSize="12px" fontWeight={400}>
                (id formulaire leadGen: {ad.leadGenFormId})&nbsp;
              </Text>
            )}
            {ad.externalId && (
              <Text fontSize="12px" fontWeight={400}>
                (id: {ad.externalId})
              </Text>
            )}
            <IconButton
              disabled={isCampaignSetupPending}
              onClick={() => {
                setAds(prevAds =>
                  prevAds.map(crea => {
                    if (crea.id === ad.id) {
                      return {
                        ...crea,
                        isEditing: true
                      };
                    }
                    return crea;
                  })
                );
              }}
            >
              <CreateIcon
                style={{
                  color: themeColors.light
                }}
              />
            </IconButton>
            {publicInventoryToggle(
              isDv360Setup,
              ad,
              setAds,
              handleSaveAd,
              isCampaignSetupPending,
              forcePublicInventoryDisabled
            )}
          </>
        ) : (
          <Item
            flex
            style={{
              alignItems: 'center'
            }}
          >
            {isLeadGen && (
              <TextField
                title="ID Formulaire leadGen"
                value={ad.leadGenFormId}
                onChange={e => {
                  setAds(prevAds =>
                    prevAds.map(crea => {
                      if (crea.id === ad.id) {
                        return {
                          ...crea,
                          leadGenFormId: e
                        };
                      }
                      return crea;
                    })
                  );
                }}
              />
            )}
            <TextField
              title="External Id"
              value={ad.externalId}
              onChange={e => {
                setAds(prevAds =>
                  prevAds.map(crea => {
                    if (crea.id === ad.id) {
                      return {
                        ...crea,
                        externalId: e
                      };
                    }
                    return crea;
                  })
                );
              }}
            />
            <IconButton
              onClick={() => {
                setAds(prevAds =>
                  prevAds.map(crea => {
                    if (crea.id === ad.id) {
                      return {
                        ...crea,
                        isEditing: false
                      };
                    }
                    return crea;
                  })
                );
                handleSaveExternalId(ad.id, ad.externalId, ad.leadGenFormId);
              }}
            >
              <CheckIcon />
            </IconButton>
            {publicInventoryToggle(
              isDv360Setup,
              ad,
              setAds,
              handleSaveAd,
              isCampaignSetupPending,
              forcePublicInventoryDisabled
            )}
          </Item>
        )}
        {ad.dexemData && (
          <Text fontWeight={700}>
            Numéro final (tracking) : {ad.dexemData.phoneNumber}
          </Text>
        )}
      </Item>
    </Row>
  );
};

AdItem.defaultProps = {
  isCampaignSetupPending: false,
  forcePublicInventoryDisabled: false
};

AdItem.propTypes = {
  isCampaignSetupPending: PropTypes.bool,
  ad: PropTypes.shape().isRequired,
  getStatusChip: PropTypes.func.isRequired,
  asset: PropTypes.shape().isRequired,
  setAds: PropTypes.func.isRequired,
  activableMedia: PropTypes.shape().isRequired,
  mediaSetupTask: PropTypes.shape().isRequired,
  handleSaveAd: PropTypes.func.isRequired,
  handleSaveExternalId: PropTypes.func.isRequired,
  forcePublicInventoryDisabled: PropTypes.bool
};

export default AdItem;
